import { SuperhumanQuestion } from './Superhuman';

export interface ReportingState {
  currentMonthData: ReportCurrentMonth;
  data: ReportItem[];
  error: boolean;
  filter: GraphFilter;
  status: boolean;
  isInitialised: boolean;
  endValues: ReportEndValues;
  transactions: TransactionItem[];
  customerNotifications: Notification[];
  superhumanSurvey: {
    survey: SuperhumanQuestion[];
    canExitSurvey: boolean;
    showModal: boolean;
  };
  transactionsPagination: {
    range: number;
    currentPage: number;
  };
}
export interface MobileReportsModel {
  customer: {
    reporting: {
      current_month: ReportCurrentMonth;
      reporting: ReportItem[];
    };
  };
}

export interface Transaction {
  transaction_date: string;
  transaction_type: TransactionType;
  transaction_value: number;
  type_translated: string;
}

export enum TransactionType {
  DEPOSIT = 'DEPOSIT',
  COUPON = 'COUPON',
  REPAYMENT = 'REPAYMENT',
  TRANSFER = 'TRANSFER',
  FEE = 'FEE',
  REIMBURSEMENT = 'REIMBURSEMENT',
  WITHDRAWAL = 'WITHDRAWAL',
  MONEY_PROMOTION = 'MONEY_PROMOTION'
}

export interface GraphFilter {
  source: GraphFilterSource;
  timePeriod: GraphFilterTimePeriod;
}

export const REPORTING_PERFORMANCE_FILTER = 'reportingPerformanceFilter';

export interface ReportCurrentMonth {
  benchmark_return: number;
  gross_return: number;
  net_return: number;
}

export enum GraphFilterSource {
  BALANCE = 'balance',
  PERFORMANCE = 'performance'
}

export enum GraphFilterTimePeriod {
  WEEK = '1w',
  MONTH = '1m',
  QUARTER = '3m',
  HALF_YEAR = '6m',
  YEAR = '1y',
  MORE_YEAR = '3y',
  MAX = 'max'
}

export enum GraphFilterDays {
  DAY = 1,
  WEEK = 7,
  MONTH = 30,
  QUARTER = 91,
  HALF_YEAR = 182,
  YEAR = 365,
  MORE_YEAR = 365 * 3
}

export interface Notification {
  id: number;
  type: string;
  attributes: NotificationAttributes;
  relationships: NotificationRelationships;
}

export interface NotificationAttributes {
  notifiable_type: 'Account' | 'Customer';
  notifiable_id: number;
  title: string;
  body: string;
  data: NotificationAttributesData;
  seen: boolean;
  updated_at: Date;
  created_at: Date;
}

export interface NotificationAttributesData {
  account_id: string;
  image: string;
  page: string;
  subtype: string;
  type: string;
}

export interface NotificationRelationships {
  notifiable: {
    links: {
      related: string;
    };
  };
}

export interface TransactionItem {
  transaction_date: string;
  transaction_type: string;
  transaction_value: number;
  type_translated: string;
}

export interface ReportEndValues {
  benchmark_return: number;
  deposits_value: number;
  end_date: string;
  end_value: number;
  fee_all: number;
  first_month: string;
  first_year: number;
  highest_return_net: number;
  last_benchmark_date: string;
  lowest_return_net: number;
  monthly_investment: number;
  money_promotions: number;
  profit_all: number;
  reimbursement_all: number;
  return_all_gross: number;
  return_all_net: number;
  simple_return_all_gross: number;
  simple_return_all_net: number;
  total_investment: number;
  withdrawal_all: number;
}

export interface ReportItem {
  date: string;
  return: number;
  end_value: number;
  transactions: any[];
}

export interface PerformanceItem {
  date: string;
  benchmark_return: number;
  return: number;
  end_value: number;
  transactions: PerformanceTransactionItem[];
}

export interface PerformanceTransactionItem {
  transaction_type: string;
  transaction_value: number;
}

export interface Referrals {
  free_feedays: number;
  is_friend: boolean;
  my_referral_customer: string;
  referral_code: string;
  referrallimit: boolean;
  total_trees: number;
}

export interface ReportItemGraph {
  date: Date;
  return: number;
  end_value: number;
  value: number;
  transactions: TransactionItem[];
}

export interface TrasnactionFinal {
  date: string;
  type: string;
  amount: string;
}

export interface EstimatedValues {
  badWithout: number;
  expectedWithout: number;
  goodWithout: number;
  bad: number;
  expected: number;
  good: number;
}

export interface StackedAreaChartData {
  columns: string[];
  data: StackedAreaChartDataItem[];
}

export interface StackedAreaChartDataItem {
  date: Date;
  bad: number;
  expected: number;
  good: number;
  badWithout: number;
  expectedWithout: number;
  goodWithout: number;
}
